export const educationData = [
  {
    id: 1,
    institution: "COMSATS University Islamabad",
    course: "Bachelor of Software engineering",
    startYear: "2018",
    endYear: "2022",
  },
];
